import {register} from './../exports/theme-sections';
import accordion from '../features/accordion';

register('page-faq', accordion);
